import { header } from '../../portfolio';
import Language from '../Language/Language';
import Navbar from '../Navbar/Navbar';
import Theme from '../Theme/Theme';
import './Header.css';

/* ------------------------- component ------------------------- */
const Header = () => {
  const { homepage, title } = header;

  /* ------------------------- render ------------------------- */
  return (
    <div>
      <div className='top-header'>
        <Language />
        <Theme />
      </div>
      <header className='header center'>
        <h3>
          {homepage ? (
            <a
              href={homepage}
              target="_blank"
              rel="noopener noreferrer"
              className='link side-effect'>
              {title}
            </a>
          ) : (
            title
          )}
        </h3>
        <Navbar />
      </header>
    </div>
  );
};

export default Header;
